import {sortedProfilesByFirstName} from './helperFunctions';

const getClientProfiles = profiles => sortedProfilesByFirstName(profiles).filter(profile => profile.permission && profile.permission.type === 'professional');

export {getClientProfiles};
export default getClientProfiles;
